export default "__VITE_ASSET__67bdfcb2__"